import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { Models } from 'models/core';
import { DeleteDialogService } from 'services/delete-dialog-service';
import { ErrorService } from 'services/error-service';
import { ForeignObjectTypeServiceService } from 'services/foreign-object-type-service-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class ForeignObjectTypeDetail {
  private foreignObjectTypeService: Models.ForeignObjectTypeService;
  protected checkDuplicateData: Models.CheckDuplicateForeignObjectTypeService = new Models.CheckDuplicateForeignObjectTypeService();

  private constructor(
    private eventAggregator: EventAggregator,
    private router: Router,
    private errorService: ErrorService,
    private toastService: ToastService,
    private foreignObjectTypeServiceService: ForeignObjectTypeServiceService,
    private deleteDialogService: DeleteDialogService
  ) {}

  @AsyncErrorHandler
  async activate(params: { Id: string }) {
    this.foreignObjectTypeService = await this.foreignObjectTypeServiceService.get(params.Id);
  }

  @AsyncErrorHandler
  async updateForeignObjectType() {
    if (await this.checkDuplicate()) return;

    await this.foreignObjectTypeServiceService.put(this.foreignObjectTypeService, this.foreignObjectTypeService.Id);
    this.eventAggregator.publish('foreignObjectTypeListReset', 1);
    this.toastService.showSuccess('service.foreignObjectsUpdated');
    this.router.navigateToRoute('foreign-object-type-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Id = this.foreignObjectTypeService.Id;
    this.checkDuplicateData.ProductId = this.foreignObjectTypeService.ProductId;
    const { IsDuplicate } = await this.foreignObjectTypeServiceService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('foreignObjectTypeIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }

  protected deleteForeignObjectType() {
    void this.deleteDialogService.confirmBeforeDelete(() => {
      this.foreignObjectTypeServiceService
        .delete(this.foreignObjectTypeService.Id)
        .then(() => {
          this.eventAggregator.publish('foreignObjectTypeListReset', 1);
          this.toastService.showSuccess('service.foreignObjectsDeleted');
          this.router.navigateToRoute('foreign-object-type-list');
        })
        .catch((err) => this.errorService.handleError(err));
    });
  }

  protected gotoParentView() {
    this.eventAggregator.publish('foreignObjectTypeListReset', 1);
    this.router.navigateToRoute('foreign-object-type-list');
  }
}
